import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import {RouterProvider,createHashRouter} from 'react-router-dom';
import {Error} from "./components/Error";
const router = createHashRouter([
  {
    path:"/",
    element:<App/>,
    errorElement:<Error/> 
  },
  {
    path:"/index.html",
    element:<App/>,
    errorElement:<Error/> 
  },
  {
    path:"/:language",
    element:<App/>,
    errorElement:<Error/> 
  },
  
  {
    path:"/:language/error/:errorType",
    element:<Error/>,
    errorElement:<Error/> 
  },
  {
    path:"/:language/:pageId",
    element:<App/>,
    errorElement:<Error/> 
  },
  {
    path:"/:language/:pageId/:subSectionId",
    element:<App/>,   
    errorElement:<Error/> 
  },
  {
    path:"/:language/:pageId/:subSectionId/:accordionId",
    element:<App/>,  
    errorElement:<Error/>
  },
]);
// type navBar = "home" | "guide" | "instruction";
i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <StrictMode>
    <RouterProvider router={router}/>
  </StrictMode>
);
